/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/speedometer_medium'
export default icon
